import { IFrameIntegrationTypeEnum } from 'api/enums';
import { immerable } from 'immer';
import { ICameraModel } from './camera.model';
import { IClientModel } from './client.model';
import { IUserModel } from './user.model';

/* -------------------------------------------------------------------------------------------------
 * IiFrameIntegrationModel
 * -----------------------------------------------------------------------------------------------*/
export interface IiFrameIntegrationModel {
    _id: string;
    client: IClientModel;
    user: IUserModel;
    camera: ICameraModel;
    token: string;
    type: IFrameIntegrationTypeEnum;
    refreshInterval: number;
    // imageUpdateFrequency?: number;

    options: {
        showTimestamp?: boolean;
        showCameraName?: boolean;
        showProjectName?: boolean;
        customText?: string;
    };
}

/* -------------------------------------------------------------------------------------------------
 * IFrameIntegrationModel
 * -----------------------------------------------------------------------------------------------*/
export class IFrameIntegrationModel {
    [immerable] = true;

    _id: string;
    client: IClientModel;
    user: IUserModel;
    camera: ICameraModel;
    token: string;
    type: IFrameIntegrationTypeEnum;
    refreshInterval: number;
    options: {
        showTimestamp?: boolean;
        showCameraName?: boolean;
        showProjectName?: boolean;
        customText?: string;
    };
    // imageUpdateFrequency?: number;

    constructor(data: Partial<IiFrameIntegrationModel>) {
        this._id = data._id;
        this.client = data.client;
        this.user = data.user;
        this.camera = data.camera;
        this.token = data.token;
        this.type = data.type;
        this.refreshInterval = data.refreshInterval;
        // this.imageUpdateFrequency = data.imageUpdateFrequency;

        this.options = {
            showTimestamp: data.options?.showTimestamp,
            showCameraName: data.options?.showCameraName,
            showProjectName: data.options?.showProjectName,
            customText: data.options?.customText || '',
        };
    }

    static fromObject(data: Partial<IiFrameIntegrationModel>): IFrameIntegrationModel {
        const model = new IFrameIntegrationModel(data);

        return model;
    }

    static cloneFrom(data: Partial<IiFrameIntegrationModel>): IFrameIntegrationModel {
        const model = new IFrameIntegrationModel(data);

        return model;
    }

    static fromObjectList(data: Partial<IiFrameIntegrationModel>[]): IFrameIntegrationModel[] {
        return data.map((row) => IFrameIntegrationModel.fromObject(row));
    }

    toObject(): IiFrameIntegrationModel {
        const data: Partial<IiFrameIntegrationModel> = {
            _id: this._id,
            client: this.client,
            user: this.user,
            camera: this.camera,
            token: this.token,
            type: this.type,
            refreshInterval: this.refreshInterval,
            // imageUpdateFrequency: this.imageUpdateFrequency,
            options: {
                showTimestamp: this.options.showTimestamp,
                showCameraName: this.options.showCameraName,
                showProjectName: this.options.showProjectName,
                customText: this.options.customText,
            },
        };

        return data as IiFrameIntegrationModel;
    }
}
